import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { Tenant } from '../../types';
interface AppLayoutProps {
  currentView: 'admin' | 'club';
  currentPage: string;
  onNavigate: (page: string) => void;
  onToggleView: () => void;
  tenant?: Tenant;
  children: React.ReactNode;
}
export function AppLayout({
  currentView,
  currentPage,
  onNavigate,
  onToggleView,
  tenant,
  children
}: AppLayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return <div className="flex h-screen w-full bg-slate-50 overflow-hidden font-sans relative" data-id="element-19">
      {/* Mobile Sidebar Backdrop */}
      {sidebarOpen && <div className="fixed inset-0 bg-slate-900/50 z-40 lg:hidden backdrop-blur-sm transition-opacity" onClick={() => setSidebarOpen(false)} data-id="element-20" />}

      <Sidebar currentView={currentView} currentPage={currentPage} onNavigate={onNavigate} onToggleView={onToggleView} tenant={tenant} isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} data-id="element-21" />
      <div className="flex-1 flex flex-col min-w-0 w-full" data-id="element-22">
        <Header currentView={currentView} currentPage={currentPage} tenant={tenant} onToggleSidebar={() => setSidebarOpen(true)} data-id="element-23" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6 lg:p-8" data-id="element-24">
          <div className="max-w-7xl mx-auto" data-id="element-25">{children}</div>
        </main>
      </div>
    </div>;
}